var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.racing_group_id)?_c('TableRender',{ref:"tableElement",attrs:{"Service":_vm.Service,"align":"center"}},[_c('TableAction',{attrs:{"buttons":[
    { name: '奖励规则', onClick: _vm.handleCoinRewardRule },
    { name: '编辑' },
    { name: '删除' }
  ],"minWidth":160}}),_c(_vm.current,{tag:"component"})],1):_c('el-alert',{attrs:{"title":"请选择组别","type":"info","show-icon":"","closable":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }